import React from 'react';
import ReactSwitch from 'react-switch';
import styled from '../../styles/styled-components';
import { Glyphicon } from '../icons';

export const Switch = styled(ReactSwitch).attrs({
  width: 40,
  height: 20,
  checkedIcon: <Glyphicon glyph="check" color="white" size="small" />,
  uncheckedIcon: <Glyphicon glyph="x" color="white" size="small" />,
})``;
